import * as Types from '@/types/bff/gql-schema';
import { UseInfiniteQueryOptions, useInfiniteQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useGetSearchMedicineDictionaryByCursorScorePageQuery } from '../search.gql.impl';

const useGetKeywordSearchMedicineDictionaryInfiniteQuery = <T>(
  variables: Types.GetSearchMedicineDictionaryByCursorScorePageQueryVariables,
  queryOptions?: UseInfiniteQueryOptions<Types.GetSearchMedicineDictionaryByCursorScorePageQuery, AxiosError, T>
) => {
  return useInfiniteQuery<Types.GetSearchMedicineDictionaryByCursorScorePageQuery, AxiosError, T>(
    useGetSearchMedicineDictionaryByCursorScorePageQuery.getKey(variables),
    ({ pageParam }) => {
      return useGetSearchMedicineDictionaryByCursorScorePageQuery.fetcher({
        request: {
          ...variables.request,
          pivotId: pageParam?.pivotId ?? undefined,
          pivotScore: pageParam?.pivotScore ?? undefined,
        },
      })();
    },
    {
      ...queryOptions,
      getNextPageParam: (lastPage: Types.GetSearchMedicineDictionaryByCursorScorePageQuery) => {
        if (lastPage.searchMedicineDictionaryByCursorScorePage.items.length === variables.request.limit) {
          return {
            pivotId: lastPage.searchMedicineDictionaryByCursorScorePage.pivotId,
            pivotScore: lastPage.searchMedicineDictionaryByCursorScorePage.pivotScore,
          };
        }
        return undefined;
      },
    }
  );
};

export default useGetKeywordSearchMedicineDictionaryInfiniteQuery;
